var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[_c('div',{staticClass:"content"},[_c('van-image',{staticClass:"icon",attrs:{"src":_vm.icon}}),_c('div',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.msg)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }